<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-col cols="12">
                <v-card>
                     <v-card-text>
                         <v-container fluid>
                              <v-layout row wrap>
                                  <v-col cols="12" md="1"><strong>Hotel</strong></v-col>
                                  <v-col cols="12" md="3">
                                      <ies-hotel-key-picker 
                                          :field="reservation.hotel_key"
                                          configuration='{"shouldEmitOnSelect":true, "selectEventName":"New Reservation: select hotel"}'>
                                      </ies-hotel-key-picker>
                                  </v-col>

                                  <v-col cols="12" md="1"><strong>Client</strong></v-col>
                                  <v-col cols="12" md="3"><v-text-field v-model="reservation.member_key"></v-text-field>*</v-col>

                                  <v-col cols="12" md="1"><strong>Status</strong></v-col>
                                  <v-col cols="12" md="3">

                                      <v-select
                                          v-model="reservation.status_key"
                                          label="Enquiry/Reservation Status"
                                          :items="statuses"
                                          autocomplete
                                      ></v-select>
                                  </v-col>

                                  <v-col cols="12" md="2"><strong>Arriving</strong></v-col>
                                  <v-col cols="12" md="4">
				                      <v-date-picker v-model="reservation.date_arrival" 
                                          class="no-print"
                                          landscape ></v-date-picker>
                                  </v-col>

                                  <v-col cols="12" md="2"><strong>Leaving</strong></v-col>
                                  <v-col cols="12" md="4">
				                      <v-date-picker v-model="reservation.date_departure" 
                                          class="no-print"
                                          landscape ></v-date-picker>
                                  </v-col>

                                    <v-col cols="12" md="2"><strong>Stay Length</strong></v-col>
                                    <v-col cols="12" md="10">{{ reservation.stay_length }} {{ reservation.stay_length === 1 ? 'Night' : 'Nights' }}</v-col>

                                    <v-col cols="12" md="2"><strong>Rooms</strong></v-col>
                                    <v-col cols="10"> 
                                        <v-layout row wrap>
                                            <v-col cols="12" v-for="(unit, index) in reservation.units">
                                            <fieldset>
                                            <v-card>
                                                <v-card-text>
                                                <v-layout wrap>

                                                    <v-col cols="12" md="6">
                                                        <v-select
                                                            :items="roomTypes"
                                                            label="Room Type"
                                                            v-model="unit.hotel_room_key"
                                                        ></v-select>
                                                    </v-col>

                                                    <v-col cols="12" md="6">
                                                        <v-select
                                                            :items="rateTypes"
                                                            label="Rate Type"
                                                            v-model="unit.rate_type_key"
                                                        ></v-select>
                                                    </v-col>

                                                    <v-col cols="12" md="1">
                                                        Adults:
                                                    </v-col>
                                                    <v-col cols="12" md="2">
                                                        <v-text-field v-model="unit.occ_adults"></v-text-field>
                                                    </v-col>

                                                    <v-col cols="12" md="1">
                                                        Old Children:
                                                    </v-col>
                                                    <v-col cols="12" md="2">
                                                        <v-text-field v-model="unit.occ_oldchildren"></v-text-field>
                                                    </v-col>


                                                    <v-col cols="12" md="1">
                                                        Children:
                                                    </v-col>
                                                    <v-col cols="12" md="2">
                                                        <v-text-field v-model="unit.occ_children"></v-text-field>
                                                    </v-col>


                                                    <v-col cols="12" md="1">
                                                        Babies:
                                                    </v-col>
                                                    <v-col cols="12" md="2">
                                                        <v-text-field v-model="unit.occ_babies"></v-text-field>
                                                    </v-col>


                                                    <v-col cols="12">
                                                        <v-btn class="ies-coral" v-on:click="removeUnit(index)"><v-icon>delete</v-icon> Delete</v-btn>
                                                    </v-col>

                                                </v-layout>
                                                </v-card-text>
                                            </v-card>
                                              </fieldset>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-btn class="ies-green" v-on:click="addBlankRoom()"><v-icon>add</v-icon> Add Room</v-btn>
                                            </v-col>
                                      </v-layout>
                                    </v-col>

                                    <v-col cols="12" md="2">Additional Fees</v-col>
                                    <v-col cols="12" 
                                           md="10" 
                                    >
                                      <fieldset>
                                        <div v-if="!hotel">Please choose a hotel to see the fees which apply</div>
                                        <div v-if="hotel && hotel.additional_fees && !hotel.additional_fees.length">The hotel has no additional fees/taxes to applied to this reservation</div>
                                        <div v-if="hotel && hotel.additional_fees && hotel.additional_fees.length">The hotel has the following fees which may be applied to this reservation:</div>
				                        <ol v-if="hotel">
                                            <li v-for="additionalFee in hotel.additional_fees">
                                                {{ additionalFee.fee_type.name }} ({{ additionalFee.name }}) - {{ additionalFee.description }} 
                                            </li>
                                        </ol>
                                      </fieldset>
                                    </v-col>

                                    <v-col cols="12" md="2" v-if="quote">Quote</v-col>
                                    <v-col cols="12" md="10" v-if="quote">
                                      <fieldset>
                                        <v-layout wrap>
                                        <v-col cols="6" md="2">Rate Total:</v-col>
                                        <v-col cols="6" md="10">{{ quote.ratesTotal }} ({{ quote.reasons.room_rates }})</v-col>

                                        <v-col cols="6" md="2">Tax/Fees Total:</v-col>
                                        <v-col cols="6" md="10">{{ quote.taxTotal }} ({{ quote.reasons.taxes ? quote.reasons.taxes : "No taxes/fees applied" }})</v-col>

                                        <v-col cols="6" md="2">Grand Total:</v-col>
                                        <v-col cols="6" md="10">{{ quote.grandTotal }} ({{ quote.reasons.grand_total }})</v-col>

                                        <v-col cols="6" md="2">Commission Amount:</v-col>
                                        <v-col cols="6" md="10">{{ quote.commission }} ({{ quote.reasons.commission }})</v-col>

                                        <v-col cols="6" md="2">Deposit:</v-col>
                                        <v-col cols="6" md="10">{{ quote.deposit }} ({{ quote.reasons.room_rates }})</v-col>

                                        <v-col cols="6" md="2">Is Advance Payment?:</v-col>
                                        <v-col cols="6" md="10">{{ quote.isAdvancePayment ? 'Yes' : 'No' }} ({{ quote.reasons.advance_payment }})</v-col>

                                        </v-layout>
                                      </fieldset>
                                    </v-col>

                                    <v-col cols="12" md="2">Notes</v-col>
                                    <v-col cols="12" md="10">
                                      <fieldset>
                                          <textarea v-model="reservation.internal_notes"></textarea>
                                      </fieldset>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn class="ies-green" v-on:click="getQuote()"><v-icon>quote</v-icon> Get Quote</v-btn>
                                        <v-btn class="ies-green" v-disabled="quote !== null" v-on:click="createNewReservation()"><v-icon>save</v-icon> Create</v-btn>
                                    </v-col>
                              </v-layout>
                          </v-container>
                      </v-card-text>
                 </v-card>
            </v-col>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user create a new reservation
     *
     */
    import axios from 'axios';
    import hotelKey from '../../common/HotelKeyPicker';
    export default {
        name: 'hotel-reservation-new',
        components: { 'ies-hotel-key-picker': hotelKey },
        props: ['hotelkey'],
        data () {
            return {
                hotel: null,
                roomTypes: [],
                rateTypes: [],
                reservation: {
                    hotel_key: 0,
                    member_key: 181115,//0,
                    status_key: 8,
                    date_arrival: null,
                    date_departure: null,
                    internal_notes: '',
                    stay_length: 1,
                    units: [
                      {
                        hotel_room_key: 0,
                        rate_type_key: 0,
                        occ_adults: 1,
                        occ_oldchildren: 0,
                        occ_children: 0,
                        occ_babies: 0
                      }
                    ]
                },
                quote: null,
                statuses: [{text: "Inactive", value: 1}, {text: "Active", value: 2}, 
				{text: "Inactive", value: 3}, {text: "Active", value: 4},
				{text: "Inactive", value: 5}, {text: "Active", value: 6}, 
				{text: "New Enquiry", value: 8}, { text: "Stay Completed", value: 9}, {text: "Re-enquiry", value: 10},
                {text: "Availability Confirmed", value: 11}, { text: "Reservation Confirmed", value: 12}, {text: "Quote Accepted", value: 13},
                {text: "Quote Expired", value: 14}, { text: "Quote Declined", value: 15}, {text: "No Availability", value: 16},
                {text: "New Cancellation", value: 17}, { text: "Cancellation Confirmed By Hotel", value: 18}, {text: "Quote Declined, Confirmed By Hotel", value: 19},
                {text: "Alternative Offered", value: 20}],
            }
        },
        methods: {
            /**
             * @method getHotel
             * 
             * Get the basic details of the hotel itself so we can use whatever we need
             * such as its additional fees etc
             */
            getHotel:function(){
                axios.get('/api/hotels/' + this.reservation.hotel_key)
                .then(function(response){
                    this.hotel = response.data;
                    console.log(response);
                }.bind(this));
            },

            /**
             * @method getRoomTypes
             *
             * Gets a collection of room types for the selected hotel
             */
            getRoomTypes:function(){
                axios.get('/api/hotels/' + this.reservation.hotel_key + "/room-types")
                .then(function(response){
                    var roomTypes = [];
                    response.data.forEach(function(roomType){
                        roomTypes.push({ text: roomType.name, value: roomType.hotel_room_key });
                    });
                    this.roomTypes = roomTypes;
                }.bind(this));
            },

            /**
             * @method getRateTypes
             *
             * Gets a collection of rate types for the selected hotel
             */
            getRateTypes:function(){
                axios.get('/api/hotels/' + this.reservation.hotel_key + "/rate-types")
                .then(function(response){
                    var rateTypes = [];
                    response.data.forEach(function(rateType){
                        rateTypes.push({ text: rateType.name, value: rateType.rate_type_key });
                    });
                    this.rateTypes = rateTypes;
                }.bind(this));
            },

            /**
             * @method addBlankRoom 
             *
             * Add an additional room to the enquiry/reservation for the user to fill in
             */
            addBlankRoom:function(){
                console.log("Add mnew reoom");
                this.reservation.units.push(
                      {
                        hotel_room_key: 0,
                        rate_type_key: 0,
                        occ_adults: 1,
                        occ_oldchildren: 0,
                        occ_children: 0,
                        occ_babies: 0
                      }
                );
                console.log(this.reservation);
            },

            getQuote:function(){
                axios.post('/api/reservations/quote', {"reservation": this.reservation})
                .then(function(response){
                    console.log("quote", response);
                    this.quote = response.data.quote;
                }.bind(this));
            },

            /**
             * @method createNewReservation
             *
             * Send details to the server so as to create a new reservation record in
             * the database
             */
            createNewReservation:function(){
                axios.post('/api/reservations/new', {"reservation": this.reservation})
                .then(function(response){
                    console.log(response);

                    // Request the res admin master component reload all data so we can see it take effect
                    this.$emit('Reservation Administration: reload');
                }.bind(this));
            }
        },

        mounted() {
            this.reservation.hotel_key = this.hotelkey;
            var self = this;

            this.$root.$on('New Reservation: select hotel', function(payload){
                self.reservation.hotel_key = payload.hotelKey;
                self.getHotel();
                self.getRoomTypes();
                self.getRateTypes();
            });
        },

        computed: {}
    }
</script>
